import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingLeaderboardEntry } from '@euler/model/coaching-progress';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors, tint } from '../../../ai-suite/theme';

const kMedals = ['🥇', '🥈', '🥉'];

/** One trainee's week: rank, name, stars earned and practices. */
export const LeaderboardRow = memo(
  ({
    entry,
    own,
    pinned,
  }: {
    entry: CoachingLeaderboardEntry;
    own: boolean;
    /** The trainee's own row below the top ten: 第 n 名. */
    pinned?: boolean;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(12),
          paddingVertical: rpx(10),
          paddingHorizontal: rpx(12),
          borderRadius: rpx(10),
          backgroundColor: own ? tint(aiColors.primary, 0.08) : 'transparent',
        }}
      >
        <View style={{ minWidth: rpx(32), alignItems: 'center' }}>
          <Typography.Text
            size={rpx(entry.rank <= 3 ? 18 : 14)}
            bold
            color={aiColors.mutedForeground}
          >
            {pinned
              ? `第 ${entry.rank} 名`
              : kMedals[entry.rank - 1] ?? String(entry.rank)}
          </Typography.Text>
        </View>
        <Typography.Text
          size={rpx(14)}
          bold={own || undefined}
          color={aiColors.foreground}
          numberOfLines={1}
          style={{ flex: 1 }}
        >
          {own ? `${entry.name}（我）` : entry.name}
        </Typography.Text>
        <Typography.Text size={rpx(12)} color={aiColors.amber}>
          {`★ ${entry.stars}`}
        </Typography.Text>
        <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
          {`${entry.practices} 次`}
        </Typography.Text>
      </View>
    );
  },
);
